module.exports = __webpack_public_path__ + "img/connection.ae71bbd8.jpg";